import { useParams, useSearchParams } from 'react-router-dom';
import useListCustomCostProviders from '@/hooks/admin/platformCosts/useListCustomCostProviders';
import EntityBreadcrumb from '../EntityBreadcrumb';
import type { PlatformCostProviderCrumbProps } from './types';

const PROVIDER_LABELS: Record<string, string> = {
    gcp: 'Google Cloud',
    twilio: 'Twilio',
    openai: 'OpenAI',
    anthropic: 'Anthropic',
    deepgram: 'Deepgram',
    stripe: 'Stripe',
    fireworks: 'Fireworks',
    manychat: 'ManyChat',
};

const CUSTOM_PROVIDER_ID_PREFIX = 'custom_';

const PlatformCostProviderCrumb = ({
    param,
    isCurrentPage = false,
}: PlatformCostProviderCrumbProps) => {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const providerId = params[param] || '';
    const month = searchParams.get('month') ?? '';
    const isCustomProvider = providerId.startsWith(CUSTOM_PROVIDER_ID_PREFIX);
    const { providers: customProviders, isLoadingProviders } = useListCustomCostProviders({
        month,
        enabled: isCustomProvider && month.length > 0,
    });

    const customProvider = customProviders.find(provider => provider.id === providerId);
    const label =
        PROVIDER_LABELS[providerId] ||
        customProvider?.displayName ||
        (isCustomProvider ? 'Custom provider' : providerId);

    return (
        <EntityBreadcrumb
            label={label}
            entityId={providerId}
            entityType="Provider"
            href={`/admin/platform-costs/${providerId}`}
            isCurrentPage={isCurrentPage}
            isLoading={isCustomProvider && isLoadingProviders && !customProvider}
        />
    );
};

export default PlatformCostProviderCrumb;
